module.exports = __webpack_public_path__ + "img/about-header-old.bd8e9151.jpg";